import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {GroupBooking} from '../../../graphql/groups.datatypes';
import _ from 'underscore';
import {formatDate,formatMoney} from '../../../utils/formatters';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    groupBookings: GroupBooking[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    selectedGroupBooking?: GroupBooking,
    setSelectedGroupBooking?: (booking: GroupBooking) => void,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedGroupBooking, setSelectedGroupBooking, groupBookings, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    const getPrimaryOccupantNames = (booking: GroupBooking) => {
        return _.flatten(booking.roomParties!.map(roomParty =>
            roomParty.members!.filter(member => member.primary_occupant).map(member => member.groupMember!.first_name + ' ' + member.groupMember!.last_name)
        )).join(', ');
    };

    const getNumberOfTravellers = (booking: GroupBooking) => {
        return booking.roomParties!.reduce((value, roomParty) => value + roomParty.members!.length, 0);
    }

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title={'Bookings'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: 120}}>Booking Id</TableCell>
                                        <TableCell>Group Name</TableCell>
                                        <TableCell>Primary Occupants</TableCell>
                                        <TableCell style={{width: 100}}>Total</TableCell>
                                        <TableCell style={{width: 100}}>Outstanding</TableCell>
                                        <TableCell style={{width: 100}}>Overdue</TableCell>
                                        <TableCell style={{width: 190}}>Date Booked</TableCell>
                                        <TableCell style={{width: 100}}># Travellers</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {groupBookings.map(booking => {
                                        return (
                                            <TableRow
                                                hover
                                                key={booking.id}
                                                selected={selectedGroupBooking === booking}
                                                onClick={() => setSelectedGroupBooking ? setSelectedGroupBooking(booking) : history.push('/group_bookings/' + booking.id)}
                                            >
                                                <TableCell>{booking.id}</TableCell>
                                                <TableCell>{booking.group!.name}</TableCell>
                                                <TableCell>{getPrimaryOccupantNames(booking)}</TableCell>
                                                <TableCell>{formatMoney(booking.cost!,true)}</TableCell>
                                                <TableCell>{formatMoney(booking.outstandingBalance!,true)}</TableCell>
                                                <TableCell>{formatMoney(booking.overduePayments!,true)}</TableCell>
                                                <TableCell>{formatDate(booking.created_at)}</TableCell>
                                                <TableCell>{getNumberOfTravellers(booking)}</TableCell>

                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                {paginatorInfo && rowsPerPage && (
              <CardActions className={classes.actions}>
                <TablePagination
                  component="div"
                  count={paginatorInfo.total}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  page={paginatorInfo.currentPage - 1}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[25, 50, 100]}
                />
              </CardActions>
            )}
          </Card>
          <TableEditBar selected={[]}/>
      </div>
    );
};

export default Results;
